import type { MapOverlay as PluginMapOverlay } from 'minerva-plugin-api';
import { MapOverlay } from '@/types/models';

/**
 * The API used to identify the overlay creator by login and now sends the numeric
 * user id instead. The login is not available to the frontend any more, so the
 * deprecated `creator` carries the id rendered as a string.
 */
export const toPluginCreator = (creatorId: number): string => String(creatorId);

export const toPluginMapOverlay = (overlay: MapOverlay): PluginMapOverlay => ({
  ...overlay,
  creatorId: overlay.creator,
  creator: toPluginCreator(overlay.creator),
});

export const toPluginMapOverlays = (overlays: MapOverlay[]): PluginMapOverlay[] =>
  overlays.map(toPluginMapOverlay);
